import { paymentApi } from "@/api/paymentApi";
import { useAuthenticationStore } from "@/stores/useAuthenticationStore";
import type { User } from "@/types/user";
import type { RouteLocationNormalizedLoaded } from "vue-router";

export function usePayments() {
  const authStore = useAuthenticationStore();
  const makePayment = async (user: User, redirect: string = null) => {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "initiateCheckout",
        ecommerce: {
          value: 19,
          currency: "USD",
        },
      });

      const result = await paymentApi.requestLink(
        user,
        redirect ?? window.location.origin + window.location.pathname,
      );
      window.location.href = result.payment_url;
    } catch (error) {
      console.error("Failed to request payment link:", error);
    }
  };

  const checkPaymentStatus = async (route: RouteLocationNormalizedLoaded<string | symbol>) => {
    if (route.query.user && route.query.payment == "success") {
      if (authStore.user.id === route.query.user) {
        try {
          const user = await paymentApi.checkPayment(authStore.user);
          if (user) {
            authStore.updateUser(user);
          }
        } catch (error) {
          console.error("Error checking payment", error);
        }
      }
    }
  };

  return { makePayment, checkPaymentStatus };
}
